import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';
import { connect } from 'react-redux';

import { VODCSSModules } from 'shared/utils/wix-connect';

import { getVideosGroupedByIds } from 'shared/selectors/videos';
import { getAllSettings, getNumberOfRows, getVideosInRowCount } from 'shared/selectors/app-settings';

import BaseVideosList from '../_base';
import Icon from 'shared/components/icon/icon';
import { GenericButton } from 'shared/components/button/button';
import ThumbnailOverlayStrip from './thumbnail-overlay/thumbnail-overlay';
import { SimpleVideoThumbnail } from 'widget/components/thumbnail/simple';

import styles from './strip.styl';

export class StripVideosListBase extends BaseVideosList {

  static displayName = 'StripVideosList';

  static propTypes = {
    ...BaseVideosList.propTypes,
    onThumbnailClick: React.PropTypes.func,
    playVideo: React.PropTypes.func,
    channelData: React.PropTypes.object,
  };

  getContainerHeightStyles() {
    const { thumbnailSize, prevPageIds, channelVideoIds, videosInRow, numberOfRows } = this.props;

    if (!thumbnailSize) {
      return null;
    }

    let containerHeight = 0;
    if (!prevPageIds.length && (channelVideoIds.length < videosInRow * numberOfRows)) {
      containerHeight = thumbnailSize.height * Math.ceil(channelVideoIds.length / videosInRow);
    } else {
      containerHeight = thumbnailSize.height * numberOfRows;
    }

    return {
      height: containerHeight,
    };
  }

  @autobind
  toVideoThumbnail(videoId) {
    const { videoByIds, onThumbnailClick, thumbnailSize, appSettings, playVideo, channelData } = this.props;
    const { width, height } = thumbnailSize;

    const video = videoByIds[videoId];

    // TODO: get rid of toVideoThumbnail, replace with component
    // see src/widget/components/videos-list/_base.js
    const handleClick = () => onThumbnailClick(video);
    const handlePlay = () => playVideo(video);

    return (
      <div styleName="thumbnail-wrapper"
           key={videoId}
           onClick={handleClick}
           style={{ height }}>
        <SimpleVideoThumbnail video={video}
                              width={width}
                              height={height} />
        <ThumbnailOverlayStrip styleName="overlay"
                               channelData={channelData}
                               videoItem={video}
                               width={width}
                               appSettings={appSettings}
                               playSelectedVideo={handlePlay} />
      </div>
    );
  }

  navButton(styleName, isDisabled, onClick) {
    const styles = classnames('nav-button', styleName, {
      disabled: isDisabled,
    });

    return (
      <GenericButton styleName={styles}
                     onClick={onClick}>
        <Icon name="arrow-strip"
              styleName="icon" />
      </GenericButton>
    );
  }

  render() {
    const { className, appSettings, prevPageIds, nextPageIds } = this.props;
    const styles = this.getContainerHeightStyles();

    if (!appSettings) {
      return null;
    }

    return (
      <section className={`qa-widget-video-list ${className}`}
               styleName="container"
               style={styles}>
        {this.list}
        {this.navButton('prev-button', !prevPageIds.length, this.toPrevPage)}
        {this.navButton('next-button', !nextPageIds.length, this.toNextPage)}
      </section>
    );
  }
}

@connect((state, ownProps) => ({
  channelVideoIds: ownProps.paginatedChannelVideos.ids,
  prevPageIds: ownProps.paginatedChannelVideos.prevPageIds,
  nextPageIds: ownProps.paginatedChannelVideos.nextPageIds,
  goBack: ownProps.paginatedChannelVideos.goBack,
  goForward: ownProps.paginatedChannelVideos.goForward,
  videoByIds: getVideosGroupedByIds(state),
  appSettings: getAllSettings(state),
  numberOfRows: getNumberOfRows(state),
  videosInRow: getVideosInRowCount(state),
}))
@VODCSSModules(styles)
export default class StripVideosList extends StripVideosListBase {}



// WEBPACK FOOTER //
// ./src/widget/components/videos-list/strip/strip.js